import { render } from "./ButtonsGroup.vue?vue&type=template&id=65f4ccc3&scoped=true"
import script from "./ButtonsGroup.vue?vue&type=script&lang=js"
export * from "./ButtonsGroup.vue?vue&type=script&lang=js"

import "./ButtonsGroup.vue?vue&type=style&index=0&id=65f4ccc3&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f4ccc3"]])

export default __exports__